import { get } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from './Loader.action';

export const CUSTOMERTRIPS_RECEIVE = 'CUSTOMERTRIP_RECEIVE';
export const CUSTOMERTRIPS_ERROR = 'CUSTOMERTRIP_ERROR';

export const receive = (data) => ({
    type: CUSTOMERTRIPS_RECEIVE,
    payload: {
        data,
    },
});

export const setError = error => ({
    type: CUSTOMERTRIPS_ERROR,
    payload: {
        error,
    },
});

export const getCustomerTripData = () => (dispatch) => {
    dispatch(showLoader());
    return get('api/erp/customerTripData')
        .then(response => response.json())
        .then((result) => {
            dispatch(receive(result));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};